import {Advertisement} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/advertisement.types';
import {GetProductBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/article_detail_page/v1/service.types';
import {
  MerchantBanner,
  mobileOnlyLinaria,
  UnstyledLink,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {convertAdvertisementToTile} from '../../../shared-deprecated/convertAdvertisementToTile';

export interface MerchantBannerComponentProps {
  className?: string;
  merchantBanner: Advertisement;
}

export function MerchantBannerComponent({
  merchantBanner,
}: MerchantBannerComponentProps) {
  const advertisementTile = convertAdvertisementToTile(merchantBanner);
  if (!advertisementTile) {
    return null;
  }

  const styledAdpMerchantBanner = (
    <StyledAdpMerchantBanner
      testId="adpMerchantBanner"
      image={advertisementTile.image}
    />
  );

  return (
    <Container>
      {advertisementTile.targetUrl === undefined ? (
        styledAdpMerchantBanner
      ) : (
        <UnstyledLink
          to={advertisementTile.targetUrl}
          data-testid="merchantBannerLink"
          aria-label={undefined}
        >
          {styledAdpMerchantBanner}
        </UnstyledLink>
      )}
    </Container>
  );
}

export const MerchantBannerView: React.FC<
  GetProductBulkResponse['merchantBannerSection']
> = ({merchantBanner}) => {
  if (!merchantBanner) {
    return null;
  }

  return <MerchantBannerComponent merchantBanner={merchantBanner} />;
};

const Container = styled.div`
  ${mobileOnlyLinaria('padding: 0 15px;')}
  padding-top: 15px;
  overflow-x: hidden;
`;

const StyledAdpMerchantBanner = styled(MerchantBanner)`
  margin-bottom: 20px;
`;
